/**
 * Kbd — reusable keyboard shortcut badge component.
 *
 * Usage:
 *   <Kbd>⌘K</Kbd>
 *   <Kbd>↑↓</Kbd>
 *   <Kbd keys={['ctrl', 'K']} />
 */
import { cn } from './cn';

const KEY_LABELS: Record<string, string> = {
  ctrl: '⌃',
  cmd: '⌘',
  meta: '⌘',
  alt: '⌥',
  opt: '⌥',
  shift: '⇧',
  enter: '↵',
  esc: 'Esc',
  tab: '⇥',
  backspace: '⌫',
  up: '↑',
  down: '↓',
  left: '←',
  right: '→',
};

interface KbdProps {
  children?: React.ReactNode;
  /** Optional shorthand: pass key array and Kbd renders them joined with '+' */
  keys?: string[];
  size?: 'sm' | 'md';
  className?: string;
}

export function Kbd({ children, keys, size = 'sm', className }: KbdProps) {
  const label = keys
    ? keys.map((k) => KEY_LABELS[k.toLowerCase()] ?? k.toUpperCase()).join('')
    : children;

  return (
    <kbd
      className={cn(
        'inline-flex select-none items-center rounded border border-border bg-muted font-mono font-medium text-muted-foreground',
        size === 'sm' ? 'h-4 px-1 text-[10px]' : 'h-5 px-1.5 text-[11px]',
        className,
      )}
    >
      {label}
    </kbd>
  );
}
